import { IBranch } from 'src/types/branches';
import { DELIVERY_TYPE_PICKER_OPTION } from 'src/constants/deliveryTypes';
import { ILangTextValidation, TTranslate } from 'src/types/main';
import { PAYMENT_TYPES } from 'src/constants/main';

export type TEditableBranch = Pick<
  IBranch,
  | 'name'
  | 'phone'
  | 'external_id'
  | 'address'
  | 'latitude'
  | 'longitude'
  | 'status'
  | 'preorder'
  | 'is_emenu'
  | 'is_curbside'
  | 'pre_select_default'
  | 'allow_all_payment_methods'
  | 'is_max_cash_payment'
  | 'delivery_fee_type'
  | 'min_order_type'
  | 'reduced_delivery_fee_type'
  | 'delivery_fee'
  | 'min_order'
  | 'areas'
  | 'reduced'
  | 'delivery_paused'
> &
  Partial<IBranch>;

export interface IBranchOrderTypeOption {
  id: DELIVERY_TYPE_PICKER_OPTION;
  type: string;
  status: boolean;
}

export interface IBranchPaymentTypeOption {
  id: PAYMENT_TYPES;
  type: string;
  status: boolean;
  isDefault?: boolean;
}

export interface IEditableBranchSection {
  id: number;
  name: TTranslate;
  isNew: boolean;
  tables: IEditableBranchSectionTable[];
}

export interface IEditableBranchSectionTable {
  id: number;
  name: TTranslate;
  isNew: boolean;
}

export interface IBranchValidation {
  details: {
    name: ILangTextValidation;
    phone: { isValid: boolean; errorText: string };
    address: boolean;
    paymentTypes: boolean;
    orderTypes: boolean;
  };
  deliverySettings: {
    reduced: {
      areaID: number[];
      delivery_fee: boolean;
    };
  };
  dineIn: {
    paymentTypes: boolean;
  };
}

export enum WORKING_HOURS_ORDER_TYPE {
  BOTH,
  DELIVERY,
  PICKUP,
}

export enum DELIVERY_CONDITION {
  DELIVERY_FEE,
  MIN_ORDER,
  REDUCED_DELIVERY_FEE,
  ORDER_MORE_THAN,
}
